
import React, { Component } from 'react';
import './event.css';
import Calendar from "./calendar";

class Event extends Component {
    constructor(props) {
        super(props);
        const currentDate = new Date();
        this.state = {
            selectedDate: null,
            currentMonth: currentDate.getMonth(),
            currentYear: currentDate.getFullYear(),
        };
    }

    render() {
        return (
            <div className={'event-container'}>
                <Calendar />
            </div>
        );
    }
}

export default Event;
